export default "__VITE_ASSET__Dspq$nxV__"